import { useConsentContext } from "lib/consent/ConsentContext";
import { ConsentCategory } from "lib/consent/ConsentTypes";

/**
 * Returns whether the user has granted consent for a given category.
 * Re-renders the consuming component when consent changes, so it's safe to
 * use as a gate (`if (!useConsent('targeting')) return null`) and as an
 * effect dependency.
 */
export const useConsent = (category: ConsentCategory): boolean => {
  return useConsentContext().hasConsent(category);
};

/**
 * Optional: exposes whether OneTrust has resolved consent at least once.
 * Useful if a component needs to distinguish "not yet resolved" from
 * "resolved and denied" (e.g. to avoid a flash).
 */
export const useConsentResolved = (): boolean => {
  return useConsentContext().resolved;
};

export type { ConsentCategory };
